/* eslint-disable */
/* this file generate by raw-icons/build.js */

import React from 'react';

const starHalf = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      d="M23.545 38.389l-12.094 6.496c-.498.267-1.105.054-1.356-.476a1.136 1.136 0 01-.093-.673l2.29-13.636a1.117 1.117 0 00-.305-.973L2.32 19.5a1.124 1.124 0 01-.048-1.519.991.991 0 01.598-.33l13.434-1.994c.326-.048.609-.262.759-.573l6.039-12.5c.255-.528.864-.736 1.36-.465.187.103.34.265.436.464l6.04 12.501c.15.311.432.525.758.573l13.434 1.994c.552.082.937.625.86 1.213a1.099 1.099 0 01-.31.636l-9.667 9.627c-.25.249-.365.615-.304.973l2.289 13.636c.098.584-.268 1.143-.817 1.247a.956.956 0 01-.632-.098l-12.094-6.496a.956.956 0 00-.91 0zm.635-23.374a.12.12 0 00-.18.106v14.807c0 .125.068.24.177.3l4.953 2.724c.08.044.17.058.259.041.225-.044.374-.278.334-.523l-.937-5.719a.476.476 0 01.124-.408l3.959-4.038a.465.465 0 00.127-.267c.032-.246-.126-.474-.352-.508l-5.502-.837a.417.417 0 01-.31-.24l-2.474-5.243a.434.434 0 00-.178-.195z"
    />
  </svg>
);

export default starHalf;
